import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'

import storeHelper from '@/store/helper'
import FileDownload from 'js-file-download'
import moment from 'moment'

export class AgentService extends BaseService {
  // danh sách cộng tác viên, agent
  static async getListAgent (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.agent.list-agent-for-web'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // check quyền ctv
  static async getRole (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.agent.get-role-by-agent-id'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // set quyền ctv
  static async setRole (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.agent.set-role'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // khóa/mở khóa tài khoản ctv
  static async lockOrActiveCTV (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.agent.update-state'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // gán ctv cho sale
  static async assignAgentToLead (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.agent.assign-agent-to-saleleader'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // chi tiết agent, ctv
  static async getOneAgent (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.agent.detail-agent'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // lịch sử xác thực ctv
  static async historyConfirmAgent (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.agent.list-history-accuracy-agent'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // xác thực ctv
  static async acceptOrRefuseAgent (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.agent.accept-refuse-accuracy-agent'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // danh sách mc ctv của user login
  static async agencyListMC (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.cstm.agency-list-mc'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // xuất excel danh sách mc ctv
  static async exportExcelMCAgent (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.cstm.agency-need-assign-sale-export'), params, {
        responseType: 'blob'
      })
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(response.data, 'Merchant-ctv' + ' ' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx')
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // chi tiết mc ctv
  static async mcDetail (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.cstm.agency-cus-detail-info'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // list mc 1 ctv
  static async getAgencyListMC (body) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.cstm.agency-need-assign-sale-list'), body)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // gán mc ctv cho sale
  static async assignMerchant (body) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.cstm.agency-pre-assign'), body)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // lịch sử gán mc ctv cho sale
  static async getListHistoryAssignSale (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.cstm.agency-assign-sale-history-list'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // chi tiết lịch sử gán mc ctv
  static async detailHistoryAssignMC (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.cstm.agency-assign-sale-history-detail'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // xác nhận chi tiền cho mc
  static async bonusReceivedConfirm (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.cstm.bonus-receive-done'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // từ chối chi tiền cho mc
  static async rejectReceivedConfirm (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.cstm.bonus-receive-reject'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // list nhóm dịch vụ
  static async getServiceList () {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.cfg.get-package-config'), {})
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // list ctv để search
  static async listAgentForSearch () {
    try {
      const response = await this.request({ auth: true }).get(storeHelper.getUrl('cnps.agent.list-agent-for-selectbox'), {})
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // xuất excel list agent
  static async exportAgent (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.agent.export-agent'), params, {
        responseType: 'blob'
      })
      if (response.headers['content-type'] === 'application/json') {
        alert('Không có dữ liệu để tải xuống')
        return
      }
      FileDownload(response.data, 'Report-list-agent' + ' ' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx')
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // thêm mới agent
  static async createAgent (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.agent.register-agent-for-web'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // cập nhật thông tin agent
  static async updateAgent (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.agent.update-agent'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // khóa tài khoản agent
  static async cancelAgent (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.agent.cancel-agent'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // mở khóa tài khoản agent
  static async approvedAgent (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.cstm.agency-need-assign-sale-export'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // check quyền agent
  static async getAgentRole (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.agent.get-role-by-agent-id'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // update quyền agent
  static async setAgentRole (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.agent.set-role'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // reset mật khẩu tài khoản agent
  static async resetPassAgent (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.agent.reset-password'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async importAgentExcel (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.agent.import-agent'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async downloadTemplateImportAgent (params) {

    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.agent.download-template-import-agent'), params, {
        responseType: 'blob'
      })
      FileDownload(response.data, 'Danh sách CTV' + ' ' + params.agentGroup + '.xlsx')
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

    // loại agency
  static async getListAgentPartner (params={}) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.agent.agent-partner.list'),params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
    }
  }


  // loại agency
  static async getListAgentGroup () {
    try {
      const response = await this.request({ auth: true }).get(storeHelper.getUrl('cnps.agent.list-agent-group'))
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
    }
  }

  static async getListPartnerSort (params={}) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.agent.partner.search'),params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
    }
  }

    static async getListLevelAgent(params={}) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.agent.agent-partner.get-agent-level'),params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
    }
  }


  static async assignDeploymentStaff(params={}) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.agent.agent-partner.update-keeper'),params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
    }
  }
  static async updateAgentPartner(params={}) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.agent.agent-partner.verify'),params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
    }
  }

  static async verifyAgentPartner(id) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.agent.agent-partner.verify-unverified').replace('{id}',id))
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
    }
  }

   static async getDetailAgentPartner(id) {
    try {
      const response = await this.request({ auth: true }).get(storeHelper.getUrl('cnps.agent.agent-partner.detail').replace('{id}',id))
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      console.log(error)
    }
  }

  // lịch sử thêm ctv qua file
  static async historyUpload () {
    try {
      const response = await this.request({ auth: true }).get(storeHelper.getUrl('cnps.agent.history-import-agent'))
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // tải file mẫu thêm ctv bằng file theo loại agency
  static async downloadInvalidImportExcel (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.agent.download-invalid-import-excel'), params.param, {
        responseType: 'blob'
      })
      FileDownload(response.data, params.fileInvalidName)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  // list ctv để search
  static async listAgentByUser (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.agent.list-agent-by-user'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getHistoryCommissions (params) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.e_scon.list-collaborator'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async uploadDetailImage (params) {
    try {
      console.log(storeHelper.getUrl('cnps.agent.upload-file-for-agent'))
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.agent.upload-file-for-agent'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
}
